{
  "nl": {
    "aiDocumentQa": {
      "buttons": {
        "chooseFile": "Bestand selecteren",
        "loadMore": "Meer laden"
      },
      "confirm": {
        "deleteDocumentChat": {
          "text": "Deze actie kan niet ongedaan worden gemaakt. Het document wordt permanent verwijderd, inclusief de volledige chatgeschiedenis.",
          "title": "Documentchat verwijderen?"
        }
      },
      "hints": {
        "documentIsBeingProcessed": "Document wordt geanalyseerd...",
        "dropFile": "Sleep hier een PDF naartoe of",
        "fileLimit": "(maximaal 10 MB)"
      },
      "labels": {
        "words": "{count} woorden"
      },
      "paragraphs": {
        "intro": "Upload een document en laat de AI de inhoud samenvatten, vraag-antwoordparen voor flashcards maken of vragen over de inhoud beantwoorden. Let op: afbeeldingen en tabellen in documenten zijn niet leesbaar voor de AI."
      },
      "statusMessages": {
        "indexing": "Achtergrondkennis wordt geïndexeerd",
        "indexingStatus": "Indexering"
      }
    }
  }
}
